import useContent from "@lib/use_content";
import { formatCurrency } from "@utils/i18n";

interface SummaryParams {
  subfares?: be.FieldValue[];
}
export default function Summary({ subfares }: SummaryParams) {
  const { data, loading, error } = useContent(["beWebSubfareSummary"]);

  // Sub the summary tokens
  let summaryString = data?.content.beWebSubfareSummary;
  let summaryA = subfares?.find((sf: be.FieldValue) => sf.field === "summary_a")?.value;
  summaryA = summaryA ? formatCurrency(Number(summaryA)) : "";
  let summaryB = subfares?.find((sf: be.FieldValue) => sf.field === "summary_b")?.value;
  summaryB = summaryB ? formatCurrency(Number(summaryB)) : "";
  if (subfares && summaryString) {
    summaryString = summaryString.replace(/_WEB_SUBFARE_SUMMARY_A_/g, summaryA || "");
    summaryString = summaryString.replace(/_WEB_SUBFARE_SUMMARY_B_/g, summaryB || "");
  }

  return !loading && summaryString && <p className="pr-3">{summaryString}</p>;
}
